import { Injectable } from '@angular/core';
import Swal from 'sweetalert2'

@Injectable()
export class MessagesService {

  optionsFormio: Object = {
    submitMessage: "",
    disableAlerts: true,
  }

  constructor() {}

  success (title?: string,msg?: string, icon?: any) {
    const message = msg ? msg : 'Registro guardado exitosamente'; 
    const titlemsg = title ? title : '';
    const icono = icon ? icon : 'success'; 
    return Swal.fire({
      customClass: {
        confirmButton: 'btn-principal',
        cancelButton: 'btn-secondary',
        icon: 'icon-class'
      },
      title: titlemsg,
      text: message,
      icon: icono,
      showConfirmButton: false,
      timer: 2000
    });
  }

  error (title?: string,msg?: string, icon?: any, confirmbtn?: any) {
    const message = msg ? msg : 'Ha ocurrido un error';
    const titlemsg = title ? title : '';
    const icono = icon ? icon : 'error';
    const btnconfirm = confirmbtn ? confirmbtn : 'Confirmar';
    return Swal.fire({
      customClass: {
        confirmButton: 'btn-principal',
        cancelButton: 'btn-secondary',
        icon: 'icon-class'
      },
      icon: icono,
      title: titlemsg,
      text: message,
      showConfirmButton: true,
      confirmButtonText: btnconfirm
    });
  }

  confirm (title?: string, msg?: string, icon?: any, confirmbtn?: any, cancelbtn?: any) {
    const message = msg ? msg : '';
    const titlemsg = title ? title : '';
    const icono = icon ? icon : 'question';
    const btnconfirm = confirmbtn ? confirmbtn : 'Confirmar';
    const btncancel = cancelbtn ? cancelbtn : 'Cancelar';
    return Swal.fire({
      customClass: {
        confirmButton: 'btn-principal',
        cancelButton: 'btn-secondary',
        icon: 'icon-class'
      },
      title: titlemsg,
      text: message,
      icon: icono,
      showCancelButton: true,
      cancelButtonText: btncancel,
      confirmButtonText: btnconfirm
    });
  }

  confirmAd (title?: string, msg?: string, icon?: any, confirmbtn?: any, cancelbtn?: any) {
    const message = msg ? msg : '';
    const titlemsg = title ? title : '';
    const icono = icon ? icon : 'success'; 
    const btnconfirm = confirmbtn ? confirmbtn : 'Confirmar';
    return Swal.fire({
      customClass: {
        confirmButton: 'btn-principal',
        cancelButton: 'btn-secondary',
        icon: 'icon-class'
      },
      title: titlemsg,
      text: message,
      icon: icono,
      confirmButtonText: btnconfirm
    });
  }
  // funcion para mensa tipo informativos
  info(title?: string, msg?: string, icon?: any, timer?:number,ShowBtnConfirm?:boolean,confirmButtonText?:string) {
    const message = msg ? msg : '';
    const titlemsg = title ? title : '';
    const icono = icon ? icon : 'success';
    const btnconfirm = confirmButtonText ? confirmButtonText : 'Aceptar';
    const Showbtnconfirm = ShowBtnConfirm ? ShowBtnConfirm : false;

    return Swal.fire({
      customClass: {
        actions: "d-flex justify-content-center",
        popup: 'views'
      },
      width: 100,
      title: titlemsg,
      text: message,
      icon: icono,
      showCancelButton: false,
      showConfirmButton: Showbtnconfirm,
      confirmButtonText: btnconfirm,
    });
  }
  WarningsS(title?: string, msg?: string, icon: 'info' | 'warning' | 'success' | 'error' = 'info', confirmbtn?: string) {
    const message = msg || '';
    const titlemsg = title || '';
    const icono = 'warning';
    const btnconfirm = confirmbtn || 'Aceptar';
  
    return Swal.fire({
      customClass: {
        confirmButton: 'btn-principal',
        cancelButton: 'btn-secondary',
        icon: 'icon-class'
      },
      icon: icono,
      title: titlemsg,
      text: message,
      showConfirmButton: true,
      confirmButtonText: btnconfirm
    });
  }
  warning(title?: string, msg?: string, icon?: any, timer?:number,ShowBtnConfirm?:boolean,confirmButtonText?:string) {
    const message = msg ? msg : '';
    const titlemsg = title ? title : '';
    const icono = icon ? icon : 'warning';
    const btnconfirm = confirmButtonText ? confirmButtonText : 'Aceptar';
    const Showbtnconfirm = ShowBtnConfirm ? ShowBtnConfirm : false;

    return Swal.fire({
      customClass: {
        actions: "d-flex justify-content-center",
        popup: 'views'
      },
      width: 100,
      title: titlemsg,
      text: message,
      icon: icono,
      showCancelButton: false,
      showConfirmButton: Showbtnconfirm,
      confirmButtonText: btnconfirm,
    });
  }
  // funcion para mensa tipo informativos
  tokenVencido(title?: string, msg?: string, icon?: any) {
    const message = msg ? msg : '';
    const titlemsg = title ? title : '';
    const icono = icon ? icon : 'info';

    return Swal.fire({
      customClass: {
        actions: "d-flex justify-content-center",
        popup: 'views token_vencido'
      },
      width: 100,
      title: titlemsg,
      text: message,
      icon: icono,
      showCancelButton: false,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
    });
  }

  loading (title?: string, msg?: string) {
    const message = msg ? msg : '';
    const titlemsg = title ? title : '';
    return Swal.fire({
      customClass: {
        confirmButton: 'btn-principal',
        cancelButton: 'btn-secondary',
        icon: 'icon-class',
        loader: 'loaderSwal'
      },
      title: titlemsg,
      text: message,
      didOpen: function () {
        Swal.showLoading();
      }
    })
  }

  custom (html: any, confirmbtn?: any, cancelbtn?: any) {
    const btnconfirm = confirmbtn ? confirmbtn : 'Confirmar';
    const btncancel = cancelbtn ? cancelbtn : 'Cancelar';
    return Swal.fire({
      customClass: {
        confirmButton: 'btn-principal',
        cancelButton: 'btn-secondary',
        icon: 'icon-class'
      },
      html: html,
      showCancelButton: cancelbtn,
      cancelButtonText: btncancel,
      confirmButtonText: btnconfirm
    })
  }

  close () {
    Swal.close();
  }


   confirmControl (title?: string, msg?: string, icon?: any, confirmbtn?: any, cancelbtn?: any) {
    const message = msg ? msg : '';
    const titlemsg = title ? title : '';
    const icono = icon ? icon : 'question';
    const btnconfirm = confirmbtn ? confirmbtn : 'Aceptar';
    return Swal.fire({
      customClass: {
        confirmButton: 'btn-principal',
        icon: 'icon-class'
      },
      title: titlemsg,
      text: message,
      icon: icono,
 
      confirmButtonText: btnconfirm
    });
  }
}